import { createLightTheme } from '@fluentui/react-components'
import { brBrandRamp } from './brandRamp'

const baseTheme = createLightTheme(brBrandRamp)

export const brTheme = {
  ...baseTheme,
  fontFamilyBase: 'ubunturegular, sans-serif',
  colorNeutralBackground1: '#FFFFFF',
  colorNeutralBackground2: '#FCFAF9',
  colorNeutralBackground3: '#F6F2F0',
  colorNeutralBackground4: '#EDE5E1',
  colorNeutralForeground1: '#172033',
  colorNeutralForeground2: '#5D6778',
  colorNeutralForeground3: '#8D97A7',
  colorBrandBackground: '#D4503A',
  colorBrandBackgroundHover: '#BD432F',
  colorBrandBackgroundPressed: '#A53927',
  colorBrandForegroundLink: '#BD432F',
  colorNeutralStroke1: '#E2D8D4',
  colorNeutralStroke2: '#D3C7C2',
  colorNeutralStrokeAccessible: '#5D6778',
}
